import type { FunctionComponent, PropsWithChildren } from 'react';
import ImageButton from './ImageButton.View';
import type {
	DispatchProps as ImageButtonDispatchProps,
	OwnProps as ImageButtonOwnProps,
	StateProps as ImageButtonStateProps
} from './ImageButton.View';
import Assets from '../../assets/Assets';

export type StateProps = ImageButtonStateProps;
export type DispatchProps = ImageButtonDispatchProps;
export type OwnProps = Omit<
	ImageButtonOwnProps,
	'src' | 'width' | 'height' | 'shadow'
> & {
	small?: boolean;
};

export type Props = StateProps & DispatchProps & OwnProps;

const CloseButton: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { small = false, ...otherProps } = props;
	const size = small ? '5vmin' : '15vmin';

	return (
		<ImageButton
			src={Assets.images.close}
			width={size}
			height={size}
			shadow
			{...otherProps}
		/>
	);
};

export default CloseButton;
